import ChatMessage from '@/Components/Common/Markdown/ChatMessage';
import { memo } from 'react';
import { processMessage, ReferenceDiv } from './utils';

const ListingChatMessages = ({
  messages = [],
  // State's
  avatar,
  loading,
  xchatId,
  optimizing,
  messageRefs,
  currentEvent,
  // Method's
  onSend,
  changeOutput,
  onRegenerate,
  handleAddModels,
  onRegenerateEdit,
  setDialogContent,
  continueResponse,
  setShowImageDialog,
  handleScriptForTTS,
  handleMessageDelete,
  handleResponseDelete,
  calculateCoinsEdit,
  handleScrollRequest,
}) => {
  const handleOpenFull = (content) => {
    setDialogContent(content);
    setShowImageDialog(true);
  };

  return (
    <>
      {messages?.map((item, index) => {
        const { realKey, isUserMessage } = processMessage(item);
        return (
          <div key={`CHAT_MESSAGE_${index}`}>
            <ChatMessage
              key={loading ? `CHAT_MESSAGE_${index}` : realKey}
              item={item}
              index={index}
              avatar={avatar}
              chatId={xchatId}
              onCapturedScript={handleScriptForTTS}
              onDelete={handleMessageDelete}
              onDeleteResponse={handleResponseDelete}
              onOpenFull={handleOpenFull}
              changeOutput={changeOutput}
              onRegenerate={onRegenerate}
              onRegenerateEdit={onRegenerateEdit}
              continueResponse={continueResponse}
              loading={loading}
              optimizing={optimizing}
              calculateCoinsEdit={calculateCoinsEdit}
              onAddModels={handleAddModels}
              onSend={onSend}
              onScrollRequest={handleScrollRequest}
            />
            <ReferenceDiv
              item={item}
              index={index}
              realKey={realKey}
              messageRefs={messageRefs}
              isUserMessage={isUserMessage}
            />
          </div>
        );
      })}
    </>
  );
};

// This are use to select for which props make the re render
const arePropsEqual = (prevProps, nextProps) => {
  if (
    prevProps.loading !== nextProps.loading ||
    prevProps.optimizing !== nextProps.optimizing ||
    prevProps.formatedDate !== nextProps.formatedDate ||
    prevProps.currentEvent !== nextProps.currentEvent ||
    prevProps.xchatId !== nextProps.xchatId
  ) {
    return false;
  }

  if (prevProps.messages?.length !== nextProps.messages?.length) {
    return false;
  }

  return prevProps.messages?.every((prevMsg, index) => {
    const nextMsg = nextProps.messages[index];

    const isArray = Array.isArray(prevMsg.data?.content);

    if (isArray) {
      if (prevMsg.length !== nextMsg.length) {
        return false;
      }
    } else {
      if (prevMsg.data?.content !== nextMsg.data?.content) {
        return false;
      }
    }

    return true;
  });
};

export default memo(ListingChatMessages, arePropsEqual);
